import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from "axios";
import "date-fns";
import { AutoDisabler, Validate, ValidationGroup } from "mui-validate";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../utils/setApiUrl";
import DeviceDataService from "../../../services/DeviceService";
import UserDataService from "../../../services/UserService";
import DeviceGroupsDataService from "../../../services/DeviceGroupsService";
import { useStyles } from "../../styles/useStyles";
import IssuedCardsService from "../../../services/IssuedCardsService";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  LocalizationProvider,
  MobileDateTimePicker,
} from "@mui/x-date-pickers";
import { styled } from "@mui/system";
import { useMediaQuery } from "@mui/material";
import { Grid } from "@material-ui/core";

require("dotenv").config();

const CustomMobileDateTimePicker = styled(MobileDateTimePicker)(
  ({ theme }) => ({
    "& .MuiInputBase-input.MuiOutlinedInput-input": {
      padding: "8.5px 14px",
    },
  })
);

// Style for consistent card height
const StyledCard = styled(Card)({
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const StyledCardContent = styled(CardContent)({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
});

function MasterWriterForm() {
  const classes = useStyles();
  const [loc] = React.useState(() => {
    const locData = JSON.parse(localStorage.getItem("loc"));
    if (locData.id !== undefined) {
      return locData.id;
    }
    return locData;
  });

  // * Users Dropdown Start
  const [users, setUsers] = useState([]);

  useEffect(() => {
    retrieveUsers();
  }, []);

  const retrieveUsers = () => {
    UserDataService.adminAll()
      .then((response) => {
        // Filter out guests - master cards are only for employees
        let filteredUsers = response.data.filter(
          (user) => user.sub_loc_name !== "Гости"
        );
        // For non-admin users, filter by assigned locations
        if (loc !== "all") {
          const locIds = (Array.isArray(loc) ? loc : [loc]).map(Number);
          filteredUsers = filteredUsers.filter(
            (user) => locIds.includes(Number(user.loc_number))
          );
        }
        filteredUsers.sort((a, b) => b.sap - a.sap);
        setUsers(filteredUsers);
      })
      .catch((e) => {
        setErrorMessages(["Cannot load user data"]);
        setIserror(true);
      });
  };

  const [userValue, setUserValue] = React.useState(users[0]);
  const [userInputValue, setUserInputValue] = React.useState("");

  // * Devices Dropdown Start
  const [devices, setDevices] = useState([]);
  const [writers, setWriters] = useState([]);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    retrieveWriters();
    retrieveGroups();
  }, []);

  const retrieveWriters = () => {
    if (loc === "all") {
      DeviceDataService.adminAllWriters()
        .then((response) => {
          setWriters(response.data);
        })
        .catch((e) => {
          setErrorMessages(["Cannot load device data"]);
          setIserror(true);
        });
    } else {
      const locIds = Array.isArray(loc) ? loc : [loc];
      Promise.all(locIds.map((locId) => DeviceDataService.getAllWriters(locId)))
        .then((responses) => {
          setWriters(responses.flatMap((response) => response.data));
        })
        .catch((e) => {
          setErrorMessages(["Cannot load device data"]);
          setIserror(true);
        });
    }
  };

  const retrieveGroups = () => {
    if (loc === "all") {
      DeviceGroupsDataService.getAllAdmin()
        .then((response) => {
          setGroups(response.data);
        })
        .catch((e) => {
          setErrorMessages(["Cannot load device data"]);
          setIserror(true);
        });
    } else {
      const locIds = Array.isArray(loc) ? loc : [loc];
      Promise.all(locIds.map((locId) => DeviceGroupsDataService.getAll(locId)))
        .then((responses) => {
          setGroups(responses.flatMap((response) => response.data));
        })
        .catch((e) => {
          setErrorMessages(["Cannot load device data"]);
          setIserror(true);
        });
    }
  };

  const [deviceValue, setDeviceValue] = React.useState(devices[0]);
  const [deviceInputValue, setDeviceInputValue] = React.useState("");

  const [writerValue, setWriterValue] = React.useState(writers[0]);
  const [writerInputValue, setWriterInputValue] = React.useState("");

  const [groupValue, setGroupValue] = React.useState(groups[0]);
  const [groupInputValue, setGroupInputValue] = React.useState("");

  const initialAdminIdState = {
    num: "",
  };

  const [adminId, setAdminId] = useState(initialAdminIdState);

  const initialHotelState = {
    num: "",
  };

  const [hotel, setHotel] = useState(initialHotelState);

  // * for error handling
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  // * Dates handling

  var today = new Date();
  const [selectedStartDate, handleStartDateChange] = useState(today);

  var nextMonth = new Date();
  nextMonth.setMonth(nextMonth.getMonth() + 3);
  const [selectedEndDate, handleEndDateChange] = useState(new Date());

  const [submitted, setSubmitted] = useState(false);

  const initialGroupState = {
    group: "",
  };

  const [group, setGroup] = useState(initialGroupState);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setGroup({ ...group, [name]: value });
  };

  // * for error handling
  const [successMessage, setSuccessMessage] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);

  const [events, setWriter] = useState([]);

  const [lost, setLost] = React.useState(false);

  const handleLost = (event) => {
    setLost(event.target.checked);
  };

  // * SelectedEndDateTime
  const [selectedDateTime, setSelectedDateTime] = useState(dayjs());

  const handleDateTimeChange = (date) => {
    const bulgarianTime = date;
    setSelectedDateTime(bulgarianTime);
  };

  const formattedEndDate = selectedDateTime.format("YYYY-MM-DD HH:mm");
  const formattedEndHours = selectedDateTime.format("HH");
  const formattedEndMinutes = selectedDateTime.format("mm");

  function getRandomEightDigitNumber() {
    let number = "";
    for (let i = 0; i < 8; i++) {
      number += Math.floor(Math.random() * 10); // Generate a random digit between 0 and 9
    }
    return parseInt(number, 10);
  }

  const saveCard = async () => {
    const requestData = {
      command: "write",
      lost: false,
      card_number: getRandomEightDigitNumber(),
      device: writerValue.mac,
      hotel: process.env.REACT_APP_HOTEL_NUMBER,
      room: 0,
      group: groupValue.id || 0,
      user_id: userValue.sap,
      user_type: 255,
      end_date: JSON.stringify(selectedDateTime)
        .replace(/\"/g, "")
        .split(".")[0],
      end_hour: formattedEndHours,
      end_minutes: formattedEndMinutes,
      end_time: formattedEndDate,
      start_time: JSON.stringify(selectedStartDate)
        .replace("T", " ")
        .replace(/.{0,9}$/, '"')
        .replace(/\"/g, ""),
      admin_id: 1,
      guest_count: 1,
      staff_count: 1,
      master_count: 1,
    };

    try {
      const issuedCard = await IssuedCardsService.create(requestData);
      console.log("Issued Card created:", issuedCard);
      // Do something with the created issued card
    } catch (error) {
      console.error("Error creating issued card:", error);
      // Handle the error
    }

    try {
      const client = axios.create({
        baseURL: API_URL,
      });

      const response = await client.post("/writeCard", requestData);

      const responseData = response.data;
      console.log(responseData);
    } catch (error) {
      console.log(error);
    }
  };

  // const saveCard = () => {
  //   var data = {
  //     group: group.group,
  //   };
  //
  //   const client = axios.create({
  //     baseURL: API_URL,
  //   });
  //
  //   client
  //     .post("/writeCard", {
  //       command: "write",
  //       lost: false,
  //       card_number: Math.random().toString().substr(2, 10),
  //       device: writerValue.mac,
  //       hotel: process.env.REACT_APP_HOTEL_NUMBER,
  //       room: 0,
  //       group: groupValue.id,
  //       user_id: userValue.sap,
  //       user_type: 255,
  //       end_time: JSON.stringify(selectedEndDate)
  //         .replace("T", " ")
  //         .replace(/.{0,9}$/, '"')
  //         .replace(/\"/g, ""),
  //       start_time: JSON.stringify(selectedStartDate)
  //         .replace("T", " ")
  //         .replace(/.{0,9}$/, '"')
  //         .replace(/\"/g, ""),
  //       admin_id: 1,
  //       // guest_count: 3,
  //       // staff_count: 1,
  //       // master_count: 1,
  //     })
  //     .then(
  //       (response) => {
  //         console.log(response);
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  // };

  const currentHost = window.location.hostname;
  const isBluestar = currentHost === "bluestar.biodit.bg";

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  return (
    <StyledCard className={classes.cardWriterBox}>
      <AppBar position="static" elevation={0} color="primary">
        <Toolbar className="px-8">
          <Typography
            variant="subtitle1"
            color="inherit"
            className="flex-1 px-12"
          >
            Мастър Карти
          </Typography>
        </Toolbar>
      </AppBar>
      <StyledCardContent>
        <div className="submit-form">
          {successMessage}
          {errorMessage}
          <ValidationGroup>
            <form className={classes.cardWriterBoxRoot}>
              <Grid container spacing={1}>
                <Grid item xs={isSmallScreen ? 12 : 6}>
                  <Validate
                    name="sap"
                    required={[true, "This field is required!"]}
                  >
                    <Autocomplete
                      value={users.sap}
                      onChange={(event, newUserValue) => {
                        setUserValue(newUserValue);
                      }}
                      inputValue={userInputValue}
                      onInputChange={(event, userInputValue) => {
                        setUserInputValue(userInputValue);
                      }}
                      id="auto-select user"
                      getOptionLabel={(users) => users.name}
                      className={classes.textField}
                      options={users}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Служител"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  </Validate>
                </Grid>
                <Grid item xs={isSmallScreen ? 12 : 6}>
                  <Validate
                    name="writer"
                    required={[true, "This field is required!"]}
                  >
                    <Autocomplete
                      value={writers.mac}
                      onChange={(event, newWriterValue) => {
                        setWriterValue(newWriterValue);
                      }}
                      inputValue={writerInputValue}
                      onInputChange={(event, writerInputValue) => {
                        setWriterInputValue(writerInputValue);
                      }}
                      id="auto-select writer"
                      getOptionLabel={(writers) => writers.name}
                      className={classes.textField}
                      options={writers}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Записващо устройство"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  </Validate>
                </Grid>
                <Grid item xs={isSmallScreen ? 12 : 6}>
                  <Validate
                    name="group"
                    required={[true, "This field is required!"]}
                  >
                    <Autocomplete
                      value={groups.mac}
                      onChange={(event, newGroupValue) => {
                        setGroupValue(newGroupValue);
                      }}
                      inputValue={groupInputValue}
                      onInputChange={(event, groupInputValue) => {
                        setGroupInputValue(groupInputValue);
                      }}
                      id="auto-select group"
                      getOptionLabel={(groups) => groups.name}
                      className={classes.textField}
                      options={groups}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Група"
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  </Validate>
                </Grid>
                <Grid item xs={isSmallScreen ? 12 : 6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <CustomMobileDateTimePicker
                      label="Крайна Дата"
                      defaultValue={dayjs()}
                      ampm={false}
                      value={selectedDateTime}
                      onChange={handleDateTimeChange}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12}>
                  <AutoDisabler>
                    <Button
                      onClick={saveCard}
                      variant="contained"
                      color="primary"
                    >
                      Издаване на карта
                    </Button>
                  </AutoDisabler>
                </Grid>
              </Grid>
            </form>
          </ValidationGroup>
        </div>
      </StyledCardContent>
    </StyledCard>
  );
}

export default MasterWriterForm;
